import { jsx as _jsx } from "react/jsx-runtime";
import { BeatLoader } from 'react-spinners';
export const LoadingSmall = () => {
    return (_jsx("div", { className: 'flex justify-center', children: _jsx(BeatLoader, { color: '#fed136', loading: true, size: 12 }) }));
};
//# sourceMappingURL=index.js.map